const tags = [
  { label: '流浪地球3', heat: '985万讨论', rank: 1 },
  { label: '繁花似锦大结局', heat: '823万讨论', rank: 2 },
  { label: '长安十二时辰', heat: '756万讨论', rank: 3 },
  { label: '国产科幻', heat: '689万讨论', rank: 4 },
  { label: '暑期档必看', heat: '612万讨论', rank: 5 },
  { label: '山海令名场面', heat: '548万讨论', rank: 6 },
  { label: '破晓行动原型', heat: '491万讨论', rank: 7 },
  { label: '高清修复', heat: '435万讨论', rank: 8 },
  { label: '烧脑悬疑', heat: '378万讨论', rank: 9 },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-50">热门话题</h2>
          <p className="text-foreground-500 text-sm mt-2">全网最热的影视讨论，看看大家都在聊什么</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {tags.map((tag) => (
            <div
              key={tag.rank}
              className="flex items-center gap-4 bg-background-100 rounded-xl p-4 border border-background-300/30 cursor-pointer hover:border-primary-500/30 transition-all duration-300 group"
            >
              <div
                className={`w-10 h-10 rounded-xl flex items-center justify-center shrink-0 ${
                  tag.rank <= 3
                    ? 'bg-primary-500/20 text-primary-400'
                    : 'bg-secondary-100 text-secondary-900'
                }`}
              >
                <span className="text-sm font-black">{tag.rank}</span>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="text-foreground-500 text-xs">#</span>
                  <span className="text-foreground-100 font-semibold text-sm truncate group-hover:text-primary-400 transition-colors">
                    {tag.label}
                  </span>
                </div>
                <div className="flex items-center gap-1.5 mt-1">
                  <i className="ri-fire-line text-accent-400 text-xs"></i>
                  <span className="text-foreground-600 text-xs">{tag.heat}</span>
                </div>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-600 group-hover:text-primary-400 transition-colors"></i>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}